export enum E_MhAndPrFormMode {
  DOB = "dob",
  FORM = "form",
}
